export default "__VITE_ASSET__D_Z7CRxz__"